import { render, staticRenderFns } from "./pcpage_history.vue?vue&type=template&id=72ad8e28&scoped=true&"
import script from "./pcpage_history.vue?vue&type=script&lang=js&"
export * from "./pcpage_history.vue?vue&type=script&lang=js&"
import style0 from "./pcpage_history.vue?vue&type=style&index=0&id=72ad8e28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ad8e28",
  null
  
)

export default component.exports